import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ourfaq",
  class: "bglight position-relative padding"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 text-center wow fadeIn\" data-wow-delay=\"300ms\"><h2 class=\"heading bottom40 darkcolor font-light2\"><span class=\"font-normal\">Validasi Dokumen TTE</span><span class=\"divider-center\"></span></h2><div class=\"col-md-8 offset-md-2 heading_space\"><p></p></div></div>", 1)
const _hoisted_5 = { class: "col-lg-12 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow" }
const _hoisted_6 = {
  key: 0,
  class: "widget logincontainer"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/success.png",
  style: {"width":"80px"},
  class: "text-center",
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-success" }, "Dokumen Valid", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/error.png",
  style: {"width":"80px"},
  class: "text-center",
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-danger" }, "Url Tidak Valid", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 2,
  class: "table"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Nama Dokumen", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Catatan", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Tanggal Tanda Tangan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_overlay, {
            show: _ctx.loadingCard,
            rounded: "sm"
          }, {
            default: _withCtx(() => [
              (!_ctx.loadingCard)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.resultData != null && _ctx.resultData.summary == 'VALID')
                      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _hoisted_8,
                            _hoisted_9,
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.resultData == null || _ctx.resultData.summary != 'VALID')
                      ? (_openBlock(), _createBlock(_component_center, { key: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _hoisted_12,
                            _hoisted_13,
                            _hoisted_14
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_15,
                    _hoisted_16,
                    (_ctx.resultData)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                          _createElementVNode("tr", null, [
                            _hoisted_18,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.nama_dokumen), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_19,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.notes), 1)
                          ]),
                          (_ctx.resultData.summary == 'VALID')
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("th", null, ": " + _toDisplayString(_ctx.formatDate(_ctx.resultData.signed_in)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ])
    ])
  ]))
}